import React from 'react'
import { product } from '../Product'

const Description = () => {
  return (
    <p>{product[0].description}</p>
  )
}

export default Description